export const moduleId = {
  type: 'number',
  minimum: 1,
  maximum: Number.MAX_SAFE_INTEGER,
};
